import { Global, BaoCao } from '../shared/global';
export const Home = {
  id: '77CCC1E2-FDBC-4644-9C99-3AB9EC1B741E',
  text: 'Trang chủ',
  link: '/home',
  icon: 'fa fa-home'
};

export const DienDans = {
  id: 'A78618AD-EF7F-44E6-A6E2-201AF7B6E2DA',
  text: 'Diễn đàn',
  link: '/diendan',
  icon: 'fa fa-home',
  huongdan: Global.App_url,
  // border: 'Co'
};



export const HoSoCongChucs_PhucHoiNghiViec = {
  id: '70CDBFE1-9004-423B-88B0-3A9AD9711A78',
  text: 'Phục hồi nghỉ việc',
  link: '/hosocongchuc/phuchoinghiviec',
  huongdan: Global.App_url,
  //border:'Co'
};

export const KhoaHocs_KhoaHoc = { id: 'C7CE86D5-2FF0-4BA5-9B93-DAA964D03B6B', text: 'Khóa học', link: '/daotaos/khoahoc', huongdan: Global.App_url };
export const KhoaHocs_DanhGia = { id: 'A78618AD-EF7F-44E6-A6E2-201AF7B6E2DA', text: 'Thảo luận & Đánh giá', link: '/khoahocs/danhgia', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang3 = { id: '70CDBFE1-9004-423B-88B0-3A9AD9711A78', text: 'Quá trình công tác', link: '/hosocongchuc/congtac', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang4 = { id: '4419D77E-56A2-496D-A211-BDB3CFDFA8DE', text: 'Quản lý công tác nước ngoài', link: '/nhaplieu/chucnang4', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang5 = { id: '24BD5439-2CEB-4162-92D4-EBD165323475', text: 'Quản lý chức vụ khác', link: '/nhaplieu/chucnang5', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang6 = { id: '23199FED-325F-48F7-8E7C-3A83E68F3340', text: 'Quản lý quan hệ gia đình', link: '/nhaplieu/chucnang6', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang7 = { id: 'CE6CEDEC-5F75-409A-8FA5-B5BF923FABFE', text: 'Quản lý danh hiệu được phong tặng', link: '/nhaplieu/chucnang7', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang8 = { id: '9734BF3A-6E36-4D85-8C49-EEE122CAD547', text: 'Quản lý thông tin tham gia Đảng', link: '/nhaplieu/chucnang8', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang9 = { id: '4C60DBAA-C69E-4878-B214-933D653D4F44', text: 'Quản lý thông tin tham gia Quân đội', link: '/nhaplieu/chucnang9', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang11 = { id: '6EAC2589-462E-4589-9BE0-35E758788A09', text: 'Quản lý quá trình đào tạo cán bộ', link: '/nhaplieu/chucnang11', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang12 = { id: '756C8AD5-A7C8-445F-89C9-AB70EEA86C64', text: 'Quản lý khen thưởng cá nhân', link: '/hosocongchuc/khenthuong', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang13 = { id: '6B3AEA43-E079-4D6A-9A27-5251958D547F', text: 'Quản lý kỷ luật', link: '/hosocongchuc/kyluat', huongdan: Global.App_url };

export const HoSoCongChucs_quatrinhnghiviec = { id: '87FDA494-9C6E-4C11-B88C-66067CC2C0AF', text: 'Quản lý quá trình nghỉ việc', link: '/hosocongchuc/quatrinhnghiviec', border: 'co', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang15 = { id: '2FC41A3D-7318-4FB9-9F5C-DA699CBB7DE6', text: 'Quản lý cán bộ nghỉ hưu', link: '/nhaplieu/chucnang15', huongdan: Global.App_url };
export const HoSoCongChucs_quyhoach = { id: '17AF6C6C-4A6D-40B4-BC0E-9654ED07DEFF', text: 'Quản lý quy hoạch', link: '/hosocongchuc/quyhoach', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang17 = { id: 'EC60D2A4-3345-490E-96CD-F4954D7DA4C8', text: 'Quản lý bổ nhiệm cán bộ', link: '/nhaplieu/chucnang17', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang18 = { id: 'F115C290-543A-4E1B-8546-275A2CF8150E', text: 'Quản lý thông tin miễn nhiệm cán bộ', link: '/nhaplieu/chucnang18', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang19 = { id: '3EE4F1C0-CE2C-4D97-8F28-590D0C1650D8', text: 'Quản lý thông tin từ chức của cán bộ', link: '/nhaplieu/chucnang19', huongdan: Global.App_url };
export const HoSoCongChucs_chucnang20 = { id: '1B2C983E-49C4-40D0-967A-BDB421BB98EE', text: 'Nhận xét đánh giá cán bộ', link: '/hosocongchuc/danhgia', huongdan: Global.App_url };

export const Lists_giaidoanquyhoach = { id: '0AF84C3A-B45C-4047-94DE-9D1D8D506200', text: 'Giai đoạn quy hoạch', link: '/danhmuc/giaidoanquyhoach', huongdan: Global.App_url };

export const TuyenDungDaoTaos_chotuyen = { id: 'C1EA12BA-A424-4DC0-BAD4-809FED778768', text: 'Quản lý thông tin chờ tuyển', link: '/nhaplieu/chotuyen', huongdan: Global.App_url };
export const TuyenDungDaoTaos_hopdonglaodong = { id: '401FF54E-6EB1-4C79-AA18-D66144345C56', text: 'Quản lý ký kết hợp đồng lao động', link: '/nhaplieu/hopdonglaodong', huongdan: Global.App_url };
//export const TuyenDungDaoTaos_chucnang52 = { id: '0EA831F9-82F2-4D10-914D-743C0F6B0AE1', text: 'Quản lý thông tin nâng bậc lương thường xuyên hoặc trước thời hạn', link: '/nhaplieu/chucnang52', huongdan: Global.App_url };
//export const TuyenDungDaoTaos_chucnang53 = { id: '27A78C03-4C89-4819-A33B-A8024EA5454A', text: 'Quản lý thông tin nâng ngạch', link: '/nhaplieu/chucnang53', huongdan: Global.App_url };
//export const TuyenDungDaoTaos_chucnang54 = { id: '3C0516A8-43BC-4CD6-8C0C-640A51C912E0', text: 'Quản lý thông tin chuyển ngạch', link: '/nhaplieu/chucnang54', huongdan: Global.App_url };
export const TuyenDungDaoTaos_daotaoboiduong = { id: 'D0C6FD63-16BC-44D5-97E7-58FFA5752265', text: 'Quản lý đào tạo, bồi dưỡng cán bộ', link: '/nhaplieu/daotaoboiduong', border: 'co', huongdan: Global.App_url };
export const TuyenDungDaoTaos_capthe = { id: '6CE9D7F7-1FDF-495C-B772-78CD9FE00A69', text: 'Quản lý cấp phát thẻ ', link: '/nhaplieu/capthe', huongdan: Global.App_url };
//export const TuyenDungDaoTaos_chucnang57 = { id: '8881EFB0-3E6B-4E44-A077-5EF28050AD75', text: 'Quản lý thông tin sổ, lập sổ', link: '/nhaplieu/chucnang57', huongdan: Global.App_url }; 
export const Ultil_tracuucanbo = {
  id: '3E366F69-BDEE-4D73-963A-6DCAA2BC070B',
  text: 'Tra cứu tìm kiếm hồ sơ cán bộ',
  link: '/hosocongchuc/tracuucanbo',
  huongdan: Global.App_url
};


export const KhoaHocs = {
  id: '',
  text: 'Khóa học',
  link: '/dash',
  icon: 'fa fa-cube',
  submenu: [
    KhoaHocs_KhoaHoc,
    KhoaHocs_DanhGia,
  ]
  //submenu: [HoSoCongChucs_HoSo, HoSoCongChucs_TraCuu, HoSoCongChucs_PhucHoiNghiViec]
};

//-------------------phân hệ
export const TuyenDungDaoTaos_hosodoituong = {
  id: 'C1EA12BA-A424-4DC0-BAD4-809FED778768',
  text: 'Quản lý hồ sơ đối tượng',
  link: '/nhaplieu/hosodoituong',
  huongdan: Global.App_url
};
export const TuyenDungDaoTaos_congviec = {
  id: '401FF54E-6EB1-4C79-AA18-D66144345C56',
  text: 'Theo dõi công việc nghiệp vụ',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};


export const TuyenDungDaoTaos = {
  id: '',
  text: ' Chờ tuyển, đào tạo, cấp phát thẻ ',
  link: '/',
  icon: 'fas fa-archive',
  submenu: [
    TuyenDungDaoTaos_chotuyen,
    TuyenDungDaoTaos_hopdonglaodong,
    TuyenDungDaoTaos_daotaoboiduong,
    TuyenDungDaoTaos_capthe,
    //TuyenDungDaoTaos_chucnang57,
  ]
};



export const tiens_phieuthu = {
  id: 'C7CE86D5-2FF0-4BA5-9B93-DAA964D03B6B',
  text: 'Phiếu thu tiền mặt',
  link: '/nhaplieu/phieuthu',
  huongdan: Global.App_url
};

export const LuongBaoHiems_congviec = {
  id: 'B82D62C4-3589-4EEC-B442-F7C85767A990',
  text: 'Quản lý các vụ việc tương trợ tư pháp',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_solieuthongkechuyenan = {
  id: '203EEA83-2293-45E6-B80D-ED7ED80565A6',
  text: 'Quản lý số liệu thống kê chuyên án',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_solieuthongkebatdt = {
  id: 'A5725EFD-4FDF-4837-AB99-5F1F6C32CB88',
  text: 'Quản lý số liệu thống kê bắt, giữ đối tượng phạm tội',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_solieuthongkenvcb = {
  id: '5CCCD93D-6444-462B-8A98-85B31691C742',
  text: 'Quản lý số liệu thống kê công tác nghiệp vụ cơ bản',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_danhsachtiepnhandttn = {
  id: '03B2DC61-5C93-4E21-B552-80450E253AEA',
  text: 'Quản lý danh sách tiếp nhận các đối tượng truy nã',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_danhsachvuan = {
  id: '237B544D-D773-4F06-8D86-2D2C9498ACEE',
  text: 'Quản lý danh sách vụ án do đơn vị thụ lý',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_danhsachvuviecv12 = {
  id: '1C74515E-65FD-4600-9AA4-ABB6074F9D22',
  text: 'Quản lý danh sách vụ việc xác minh theo yêu cầu của V12',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_danhsachv03 = {
  id: 'CC2254F4-BEB6-4D41-A246-7722D3939ED4',
  text: 'Quản lý chia sẻ thông tin tương trợ tư pháp với V03',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const LuongBaoHiems_danhsachtailieu = {
  id: 'CC2254F4-BEB6-4D41-A246-7722D3939ED4',
  text: 'Quản lý văn bản quy phạm pháp luật tham gia và trực tiếp xây dựng',
  link: '/nhaplieu/congviec',
  huongdan: Global.App_url
};

export const DaoTaos_ChiPhiDaoTao = { id: '5CCCD93D-6444-462B-8A98-85B31691C742', text: 'Chi phí đào tạo', link: '/daotaos/chiphidaotao', huongdan: Global.App_url };
export const DaoTaos_ChiPhiBoiHoan = { id: '03B2DC61-5C93-4E21-B552-80450E253AEA', text: 'Chi phí bồi hoàn', link: '/daotaos/chiphiboihoan', huongdan: Global.App_url };
export const LuongBaoHiems_dienbienluongngachbac = { id: '29560667-BE7F-4BBA-AD5E-2C0C3F00474E', text: 'Quản lý diễn biến lương ngạch bậc', link: '/daotaos/dienbienluongngachbac', huongdan: Global.App_url };
export const LuongBaoHiems_dienbienphucapluong = { id: 'CC2254F4-BEB6-4D41-A246-7722D3939ED4', text: 'Quản lý diễn biến phụ cấp lương', link: '/daotaos/dienbienphucapluong', huongdan: Global.App_url };

export const LuongBaoHiems_nangluong = { id: 'BC1ADD1C-6971-4D12-9BAF-C3E1B682FF0A', text: 'Quản lý nâng lương', link: '/daotaos/nangluong', huongdan: Global.App_url };
// loại
export const payroll_thunhap = {
  id: 'FBF4ED65-8450-4BED-96F5-BAF239295076',
  text: 'Thu nhập không thường xuyên',
  link: '/ketoan/thunhapkhongthuongxuyen',
  huongdan: Global.App_url
};
export const payroll_khautru = {
  id: '25425981-B501-4474-99F2-C1436459F145',
  text: 'Khấu trừ không thường xuyên',
  link: '/ketoan/khautrukhongthuongxuyen',
  huongdan: Global.App_url
};
export const payroll_tinhluong = {
  id: 'B5925C7F-6898-4C54-AF64-DBA3F9BEAC0E',
  text: 'Tính lương',
  link: '/ketoan/tinhluong',
  border: 'Co',
  huongdan: Global.App_url
};

//------- 
export const DaoTaos = {
  id: '',
  text: 'Đào tạo',
  icon: 'fas fa-dollar-sign',
  submenu: [
   
  ]
};



export const SatHachs_CauHoi = { id: '362476FE-F56F-4839-A450-6EA18536DE48', text: 'Ngân hàng câu hỏi', link: '/sathachs/cauhoi', huongdan: Global.App_url };

export const SatHachs_DeThi = { id: 'FD38F3BB-8479-42FC-B765-C38C46A012B2', text: 'Bộ đề thi', link: '/sathachs/dethi', huongdan: Global.App_url };
export const SatHachs_LoaiCauHoi = { id: '58389DA4-54C9-4CEC-80E7-CD126C145FA0', text: 'Loại câu hỏi', link: '/sathachs/loaicauhoi', huongdan: Global.App_url };

export const SatHachs_LoaiThi = { id: 'D10885DE-5B38-47AF-B9CB-570C080209DD', text: 'Loại đề thi', link: '/sathachs/loaithi', huongdan: Global.App_url };


export const SatHachs_DotThi = { id: '18A53AE2-AFF0-42AB-985A-2DB6692A9210', text: 'Đợt thi', link: '/sathachs/dotthi', huongdan: Global.App_url, border: 'co' };
export const SatHachs_DanhSachThi = { id: '8801AFE0-0045-4DD6-967F-3DC041B6B20A', text: 'Danh sách thi', link: '/sathachs/danhsachthi', huongdan: Global.App_url };
export const SatHachs_ThamSoThi = { id: 'A9E5BD5E-6F40-42C1-9192-6C637B61C2B1', text: 'Tham số thi', link: '/sathachs/thamsothi', huongdan: Global.App_url, border: 'co' };
export const ThiDuas_chucnang109 = { id: 'DFDCC52C-8351-48AB-A611-2E1B5DCF3967', text: 'Đề nghị khen cá nhân', link: '/thidua/denghicanhan', huongdan: Global.App_url };
export const ThiDuas_chucnang104 = { id: '9274124E-C622-41D8-9F73-5CE66175072F', text: 'Duyệt đề nghị khen cá nhân', link: '/thidua/duyetcanhan', huongdan: Global.App_url };
export const ThiDuas_chucnang101 = { id: '68E3EAA3-C34F-45FB-8FE0-6205048012B1', text: 'Duyệt đề nghị khen tập thể', link: '/thidua/duyettapthe', huongdan: Global.App_url, border: 'co' };
export const SatHachs = {
  id: '',
  text: 'Sát hạch',
  icon: 'fas fa-certificate',
  submenu: [
    SatHachs_CauHoi,
    SatHachs_DeThi,
    SatHachs_LoaiCauHoi,    
    SatHachs_LoaiThi,
    SatHachs_DotThi,
    SatHachs_DanhSachThi,
    SatHachs_ThamSoThi
  ]
};


//----------------------Bao cao-------------------------------------------------------

export const Reports_thongketonghop = {
  id: BaoCao.BC12_ThongKeTongHop,
  text: 'Thống kê tổng hợp',
  link: '/baocao/thongketonghop/' + BaoCao.BC12_ThongKeTongHop,
  huongdan: Global.App_url
};
export const Reports_thongkecongvannghiepvu = {
  id: BaoCao.BC13_ThongKeCongVanNghiepVu,
  text: 'Thống kê công văn nghiệp vụ',
  link: '/baocao/thongkecongvannghiepvu/' + BaoCao.BC13_ThongKeCongVanNghiepVu,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheodiaphuong = {
  id: BaoCao.BC14_ThongKeCongVanDenTheoDiaPhuong,
  text: 'Thống kê công văn đến theo địa phương',
  link: '/baocao/thongkecongvandentheodiaphuong/' + BaoCao.BC14_ThongKeCongVanDenTheoDiaPhuong,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheoloaihinh = {
  id: BaoCao.BC15_ThongKeCongVanDenTheoLoaiHinhCV,
  text: 'Thống kê công văn đến theo loại hình công văn',
  link: '/baocao/thongkecongvandentheoloaihinh/' + BaoCao.BC15_ThongKeCongVanDenTheoLoaiHinhCV,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheothoigian = {
  id: BaoCao.BC16_ThongKeCongVanDenTheoThoiGian,
  text: 'Thông kê công văn đến theo thời gian',
  link: '/baocao/thongkecongvandentheothoigian/' + BaoCao.BC16_ThongKeCongVanDenTheoThoiGian,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheotoidanh = {
  id: BaoCao.BC17_ThongKeCongVanDenTheoToiDanh,
  text: 'Thống kê công văn đến theo tội danh',
  link: '/baocao/thongkecongvandentheotoidanh/' + BaoCao.BC17_ThongKeCongVanDenTheoToiDanh,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheolinhvuc = {
  id: BaoCao.BC18_ThongKeCongVanDenTheoLinhVuc,
  text: 'Thống kê công văn đến theo lĩnh vực',
  link: '/baocao/thongkecongvandentheolinhvuc/' + BaoCao.BC18_ThongKeCongVanDenTheoLinhVuc,
  huongdan: Global.App_url
};

export const Reports_thongkecongvandentheovuviec = {
  id: BaoCao.BC19_ThongKeCongVanDenTheoVuViec,
  text: 'Thống kê công văn đến theo vụ việc',
  link: '/baocao/thongkecongvandentheovuviec/' + BaoCao.BC19_ThongKeCongVanDenTheoVuViec,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheocongviechc = {
  id: BaoCao.BC20_ThongKeCongVanDenTheoCongViecHC,
  text: 'Thống kê công văn đến theo công việc hành chính',
  link: '/baocao/thongkecongvandentheocongviechc/' + BaoCao.BC20_ThongKeCongVanDenTheoCongViecHC,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheoloaian = {
  id: BaoCao.BC21_ThongKeCongVanDenTheoLoaiAn,
  text: 'Thống kê công văn đến theo loại án',
  link: '/baocao/thongkecongvandentheoloaian/' + BaoCao.BC21_ThongKeCongVanDenTheoLoaiAn,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheoquocgia = {
  id: BaoCao.BC22_ThongKeCongVanDenTheoQuocGia,
  text: 'Thống kê công văn đến theo quốc gia',
  link: '/baocao/thongkecongvandentheoquocgia/' + BaoCao.BC22_ThongKeCongVanDenTheoQuocGia,
  huongdan: Global.App_url
};
export const Reports_thongkecongvandentheodokhan = {
  id: BaoCao.BC23_ThongKeCongVanDenTheoDoKhan,
  text: 'Thống kê công văn đến theo độ khẩn',
  link: '/baocao/thongkecongvandentheodokhan/' + BaoCao.BC23_ThongKeCongVanDenTheoDoKhan,
  huongdan: Global.App_url
};
export const Reports_thongkechuyenan = {
  id: BaoCao.BC24_ThongKeChuyenAn,
  text: 'Thống kê chuyên án',
  link: '/baocao/thongkechuyenan/' + BaoCao.BC24_ThongKeChuyenAn,
  huongdan: Global.App_url
};
export const Reports_thongkesolieubatgiutoipham = {
  id: BaoCao.BC25_ThongKeSoLieuBatGiuToiPham,
  text: 'Thống kê số liệu bắt, giữ đối tượng phạm tội',
  link: '/baocao/thongkesolieubatgiutoipham/' + BaoCao.BC25_ThongKeSoLieuBatGiuToiPham,
  huongdan: Global.App_url
};
export const Reports_thongkesonguoinghienmatuy = {
  id: BaoCao.BC26_ThongKeNguoiNghienMaTuyCoHoSo,
  text: 'Thống kê số liệu người nghiện ma túy có hồ sơ quản lý',
  link: '/baocao/thongkesonguoinghienmatuy/' + BaoCao.BC26_ThongKeNguoiNghienMaTuyCoHoSo,
  huongdan: Global.App_url
};
export const Reports_baocaocongvandentheodonvi = {
  id: BaoCao.BC35_BaoCaoCongVanDenTheoDonVi,
  text: 'Báo cáo công văn đến theo đơn vị',
  link: '/baocao/baocaocongvandentheodonvi/' + BaoCao.BC35_BaoCaoCongVanDenTheoDonVi,
  huongdan: Global.App_url
};

export const Reports_baocaocongvandentheodomat = {
  id: BaoCao.BC36_BaoCaoCongVanDenTheoDoMat,
  text: 'Báo cáo công văn đến theo độ mật',
  link: '/baocao/baocaocongvandentheodomat/' + BaoCao.BC36_BaoCaoCongVanDenTheoDoMat,
  huongdan: Global.App_url
};
export const Reports_baocaocongvandentheonguoiky = {
  id: BaoCao.BC37_BaoCaoCongVanDenTheoNguoiKy,
  text: 'Báo cáo công văn đến theo người ký',
  link: '/baocao/baocaocongvandentheonguoiky/' + BaoCao.BC37_BaoCaoCongVanDenTheoNguoiKy,
  huongdan: Global.App_url
};
export const Reports_baocaocongvanditheovuviec = {
  id: BaoCao.BC38_BaoCaoCongVanDiTheoVuViec,
  text: 'Báo cáo công văn đi theo vụ việc',
  link: '/baocao/baocaocongvanditheovuviec/' + BaoCao.BC38_BaoCaoCongVanDiTheoVuViec,
  huongdan: Global.App_url
};
export const Reports_baocaocongvanditheodoituong = {
  id: BaoCao.BC39_BaoCaoCongVanDiTheoDoiTuong,
  text: 'Báo cáo công văn đi theo đối tượng',
  link: '/baocao/baocaocongvanditheodoituong/' + BaoCao.BC39_BaoCaoCongVanDiTheoDoiTuong,
  huongdan: Global.App_url
};
export const Reports_baocaocongvanditheoloaitoidanh = {
  id: BaoCao.BC40_BaoCaoCongVanDiTheoLoaiToiDanh,
  text: 'Báo cáo công văn đi theo loại tội danh',
  link: '/baocao/baocaocongvanditheoloaitoidanh/' + BaoCao.BC40_BaoCaoCongVanDiTheoLoaiToiDanh,
  huongdan: Global.App_url
};
export const Reports_baocaovuviectheoquocgia = {
  id: BaoCao.BC50_BaoCaoVuViecTheoQuocGia,
  text: 'Báo cáo vụ việc theo quốc gia',
  link: '/baocao/baocaovuviectheoquocgia/' + BaoCao.BC50_BaoCaoVuViecTheoQuocGia,
  huongdan: Global.App_url
};
export const Reports_baocaovuviectheodonvi = {
  id: BaoCao.BC51_BaoCaoVuViecTheoDonVi,
  text: 'Báo cáo vụ việc theo đơn vị',
  link: '/baocao/baocaovuviectheodonvi/' + BaoCao.BC51_BaoCaoVuViecTheoDonVi,
  huongdan: Global.App_url
};
export const Reports_baocaovuviectheolinhvuc = {
  id: BaoCao.BC52_BaoCaoVuViecTheoLinhVuc,
  text: 'Báo cáo vụ việc theo lĩnh vực',
  link: '/baocao/baocaovuviectheolinhvuc/' + BaoCao.BC52_BaoCaoVuViecTheoLinhVuc,
  huongdan: Global.App_url
};
export const Reports_baocaodoituongtheotoidanh = {
  id: BaoCao.BC53_BaoCaoDoiTuongTheoToiDanh,
  text: 'Báo cáo đối tượng theo tội danh',
  link: '/baocao/baocaodoituongtheotoidanh/' + BaoCao.BC53_BaoCaoDoiTuongTheoToiDanh,
  huongdan: Global.App_url
};
export const Reports_baocaodoituongtheotinhthanh = {
  id: BaoCao.BC54_BaoCaoDoiTuongTheoTinhThanh,
  text: 'Báo cáo đối tượng theo tỉnh thành',
  link: '/baocao/baocaodoituongtheotinhthanh/' + BaoCao.BC54_BaoCaoDoiTuongTheoTinhThanh,
  huongdan: Global.App_url
};
export const Reports_baocaodoituongtheonguoiky = {
  id: BaoCao.BC55_BaoCaoDoiTuongTheoNguoiKy,
  text: 'Báo cáo đối tượng theo người ký',
  link: '/baocao/baocaodoituongtheonguoiky/' + BaoCao.BC55_BaoCaoDoiTuongTheoNguoiKy,
  huongdan: Global.App_url
};
export const Reports_baocaodoituongtheovuviec = {
  id: BaoCao.BC56_BaoCaoDoiTuongTheoVuViec,
  text: 'Báo cáo đối tượng theo vụ việc',
  link: '/baocao/baocaodoituongtheovuviec/' + BaoCao.BC56_BaoCaoDoiTuongTheoVuViec,
  huongdan: Global.App_url
};
export const Reports_baocaotheonguoiphutrach = {
  id: BaoCao.BC57_BaoCaoTheoNguoiPhuTrach,
  text: 'Báo cáo theo người phụ trách',
  link: '/baocao/baocaotheonguoiphutrach/' + BaoCao.BC57_BaoCaoTheoNguoiPhuTrach,
  huongdan: Global.App_url
};

export const Reports_baocaothongkecongtacnghiepvucoban = {
  id: BaoCao.BC70_BaoCaoThongKeCongTacNghiepVuCoBan,
  text: 'Báo cáo thống kê công tác nghiệp vụ cơ bản',
  link: '/baocao/baocaothongkecongtacnghiepvucoban/' + BaoCao.BC70_BaoCaoThongKeCongTacNghiepVuCoBan,
  huongdan: Global.App_url
};
export const Reports_baocaovanban = {
  id: BaoCao.BC71_BaoCaoDanhSachCacVanBanQuyPhamPhapLuat,
  text: 'Báo cáo DS các VB QPPL tham gia và trực tiếp xây dựng',
  link: '/baocao/baocaovanban/' + BaoCao.BC71_BaoCaoDanhSachCacVanBanQuyPhamPhapLuat,
  huongdan: Global.App_url
};
export const Reports_baocaodanhsachvuviecxacminh = {
  id: BaoCao.BC72_BaoCaoDanhSachCacVuViecXacMinhTheoYeuCau,
  text: 'Danh sách các vụ việc xác minh theo yêu cầu',
  link: '/baocao/baocaodanhsachvuviecxacminh/' + BaoCao.BC72_BaoCaoDanhSachCacVuViecXacMinhTheoYeuCau,
  huongdan: Global.App_url
};
export const Reports_bangkecacvuandodonvithuly = {
  id: BaoCao.BC73_BangKeCacVuAnDoDonViThuLy,
  text: 'Bảng kê các vụ án do đơn vị thụ lý',
  link: '/baocao/bangkecacvuandodonvithuly/' + BaoCao.BC73_BangKeCacVuAnDoDonViThuLy,
  huongdan: Global.App_url
};
export const Reports_danhsachtiepnhancacdttn = {
  id: BaoCao.BC74_DanhSachTiepNhanCacDoiTuongTruyNa,
  text: 'Danh sách tiếp nhận các đối tượng truy nã',
  link: '/baocao/danhsachtiepnhancacdttn/' + BaoCao.BC70_BaoCaoThongKeCongTacNghiepVuCoBan,
  huongdan: Global.App_url
};
export const Reports_baocaovuviectuongtro = {
  id: BaoCao.BC75_DanhSachCacVuViecTuongTroTuPhapDaGiaiQuyet,
  text: 'Báo cáo danh sách các vụ việc tương trợ tư pháp đã, đang giải quyết',
  link: '/baocao/baocaovuviectuongtro/' + BaoCao.BC75_DanhSachCacVuViecTuongTroTuPhapDaGiaiQuyet,
  huongdan: Global.App_url
};
export const Reports_danhsachvuviecvuanhuongdan = {
  id: BaoCao.BC76_DanhSachCacVuViecVuAnHuongDanThamDinh,
  text: 'Danh sách các vụ việc, vụ án hướng dẫn, thẩm định',
  link: '/baocao/danhsachvuviecvuanhuongdan/' + BaoCao.BC76_DanhSachCacVuViecVuAnHuongDanThamDinh,
  huongdan: Global.App_url
};

export const Reports_soyeulylich2c = { id: '65C9FEF8-1411-4F60-BB9C-244311336858', text: 'Sơ yếu lý lịch cán bộ, công chức (Mẫu 2C)', link: '/baocao/soyeulylich2c/65C9FEF8-1411-4F60-BB9C-244311336858', huongdan: Global.App_url };
export const Reports_thongketanggiamcanbo = { id: '47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F', text: 'Thống kê bài viết theo số báo', link: '/baocao/thongketanggiamcanbo/47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F', huongdan: Global.App_url };
export const Reports_thongkechatluongcongchuc = { id: '4BDC6A56-C92F-4160-8655-A123890218E1', text: 'Báo cáo thống kê số lượng, chất lượng công chức', link: '/baocao/thongkechatluongcongchuc/4BDC6A56-C92F-4160-8655-A123890218E1', huongdan: Global.App_url };
export const Reports_thongkechatluonglaodonghopdong = { id: '99496F5D-873D-4CB3-9387-A348C330FFB0', text: 'Báo cáo thống kê chất lượng lao động hợp đồng', link: '/baocao/thongkechatluonglaodonghopdong/99496F5D-873D-4CB3-9387-A348C330FFB0', huongdan: Global.App_url };
//export const Reports_1040816 = { id: 'B8BD15D9-5805-4AE6-A66B-51AEF4393978', text: 'Báo cáo quá trình công tác của cán bộ công chức', link: '/baocao/1040816', huongdan: Global.App_url };
//export const Reports_1040817 = { id: 'ECE8C9E9-E48F-4245-8733-5D5D76F4AB62', text: 'Báo cáo thống kê biên chế và hợp đồng', link: '/baocao/1040817', huongdan: Global.App_url };
//export const Reports_1040818 = { id: '951E8C39-0AB0-4F22-914A-0829015DDE34', text: 'Báo cáo tổng hợp cán bộ công chức theo hợp đồng', link: '/baocao/1040818', huongdan: Global.App_url };
//export const Reports_1040819 = { id: '9F269D4E-8BC4-4E8C-8925-32597EBED9D1', text: 'Báo cáo danh sách quan hệ gia đình', link: '/baocao/1040819', huongdan: Global.App_url };
//export const Reports_1040820 = { id: '3C23B951-1F36-4EC4-9029-2C11279E823E', text: 'Báo cáo chất lượng cán bộ trong cơ quan nhà nước', link: '/baocao/1040820', huongdan: Global.App_url };
//export const Reports_1040821 = { id: 'D4B584C6-A3E5-4441-B07F-8807B017630A', text: 'Báo cáo sắp xếp cán bộ công chức', link: '/baocao/1040821', huongdan: Global.App_url };
//export const Reports_1040822 = { id: '3CD8C834-20DA-4123-881E-E5A7B77A1A30', text: 'Báo cáo thống kê cán bộ đủ tiêu chuẩn về hưu', link: '/baocao/1040822', huongdan: Global.App_url };
export const Reports_thongkecanbonghiviec = { id: '850DB0F0-FB95-4210-B646-9D36B69E802E', text: 'Báo cáo thống kê cán bộ nghỉ việc', link: '/baocao/thongkecanbonghiviec/850DB0F0-FB95-4210-B646-9D36B69E802E', huongdan: Global.App_url };
export const Reports_thongkecanbonghihuu = { id: '7AE62001-9E86-4C83-AA53-28F5545B995D', text: 'Báo cáo thống kê cán bộ nghỉ hưu', link: '/baocao/thongkecanbonghihuu/7AE62001-9E86-4C83-AA53-28F5545B995D', huongdan: Global.App_url };
export const Reports_danhsachcanbothamgiabhxh = { id: '7EB0267F-59B9-4440-8ADE-24A54B3DEB97', text: 'Thống kê danh sách cán bộ tham gia BHXH', link: '/baocao/danhsachcanbothamgiabhxh/7EB0267F-59B9-4440-8ADE-24A54B3DEB97', huongdan: Global.App_url };
export const Reports_bangtonghopchucdanh = { id: '0078B7D7-3A15-4B65-99EE-EA912E157247', text: 'Bảng tổng hợp chức danh công việc của từng đơn vị', link: '/baocao/bangtonghopchucdanh/0078B7D7-3A15-4B65-99EE-EA912E157247', huongdan: Global.App_url };
export const Reports_danhsachkyluat = { id: '78BCE38E-45BA-4F0A-9035-8FAB79CC12FA', text: 'Báo cáo danh sách thông tin kỷ luật cán bộ', link: '/baocao/danhsachkyluat/78BCE38E-45BA-4F0A-9035-8FAB79CC12FA', huongdan: Global.App_url };
export const Reports_danhsachkhenthuong = { id: '14121372-DC98-4B64-A4E9-B6339B3CCBCC', text: 'Báo cáo danh sách thông tin khen thưởng cán bộ', link: '/baocao/danhsachkhenthuong/14121372-DC98-4B64-A4E9-B6339B3CCBCC', huongdan: Global.App_url };
export const Reports_danhsachcongchuc = { id: '6E5878CC-925D-4697-9B4A-05F90B2AF7CC', text: 'Báo cáo thống kê danh sách công chức', link: '/baocao/danhsachcongchuc/6E5878CC-925D-4697-9B4A-05F90B2AF7CC', huongdan: Global.App_url };
//export const Reports_tonghoptanggiamcanbo = { id: 'B3490399-3E90-4033-9D0D-74EA86DBCD72', text: 'Bảng tổng hợp tăng giảm cán bộ, công chức', link: '/baocao/tonghoptanggiamcanbo ', huongdan: Global.App_url };
export const Reports_chitiettanggiamcanbo = { id: '4386BB57-B602-4B0E-9588-ACD69B0D6755', text: 'Danh sách chi tiết tăng giảm cán bộ, công chức', link: '/baocao/chitiettanggiamcanbo/4386BB57-B602-4B0E-9588-ACD69B0D6755', huongdan: Global.App_url };
export const Reports_dieuchuyencanbo = { id: '87AF78B6-4960-4289-94C4-EE6152509D2F', text: 'Danh sách cán bộ chuyển bộ phận, phòng ban, đơn vị', link: '/baocao/dieuchuyencanbo/87AF78B6-4960-4289-94C4-EE6152509D2F', huongdan: Global.App_url };
export const Reports_danhsachcanbodabonhiem = { id: '4C80CC92-A9E9-4A32-B77C-EF6E47D65701', text: 'Danh sách cán bộ đã bổ nhiệm', link: '/baocao/danhsachcanbodabonhiem/4C80CC92-A9E9-4A32-B77C-EF6E47D65701', huongdan: Global.App_url };
export const Reports_danhsachcanbohethanbonhiem = { id: '1AFAB896-F84E-4C7B-A235-B0046A56BF05', text: 'Danh sách cán bộ hết hạn bổ nhiệm', link: '/baocao/danhsachcanbohethanbonhiem/1AFAB896-F84E-4C7B-A235-B0046A56BF05', huongdan: Global.App_url };
export const Reports_danhsachcanbothaydoichucvu = { id: '0E96EEA9-CF39-48C1-AB11-D43541047C53', text: 'Danh sách cán bộ thay đổi chức vụ', link: '/baocao/danhsachcanbothaydoichucvu/0E96EEA9-CF39-48C1-AB11-D43541047C53', huongdan: Global.App_url };
//export const Reports_1040837 = { id: 'B8705922-F245-469C-9860-DB627CD8BDA7', text: 'Danh sách cán bộ nghỉ việc', link: '/baocao/1040837', huongdan: Global.App_url };
// const Reports_1040838 = { id: 'F7DEA2D7-31ED-435C-963A-3BF6DDBE6B94', text: 'Danh sách cán bộ được tiếp nhận', link: '/baocao/1040838', huongdan: Global.App_url };
export const Reports_tonghopdotuoicanbo = { id: '0A885321-2BB3-4391-AA2E-27D61D3AB062', text: 'Bảng tổng hợp độ tuổi cán bộ, công chức', link: '/baocao/tonghopdotuoicanbo/0A885321-2BB3-4391-AA2E-27D61D3AB062', huongdan: Global.App_url };


//export const Reports_1040900 = { id: 'DE4D725A-06D4-4D25-9634-24887462CC86', text: 'Báo cáo danh sách và tiền lương công chức', link: '/baocao/1040900', huongdan: Global.App_url };
//export const Reports_1040901 = { id: '654FFDE9-9277-469A-B3DD-EC57567FFDA2', text: 'Báo cáo thống kê tiền lương theo ngạch bậc', link: '/baocao/1040901', huongdan: Global.App_url };
//export const Reports_1040902 = { id: 'DC4CF216-510E-4F65-B8B7-F3BAACFC531A', text: 'Báo cáo bảng lương công chức', link: '/baocao/1040902', huongdan: Global.App_url };
//export const Reports_1040903 = { id: 'AB5290C5-0FA4-4122-B261-04A81BC2A628', text: 'Báo cáo bảng lương hợp đồng 68', link: '/baocao/1040903', huongdan: Global.App_url };
//export const Reports_1040904 = { id: '73D6DCE2-5576-412B-98E4-F9B2F3CE9659', text: 'Bảng thanh toán lương', link: '/baocao/1040904', huongdan: Global.App_url };
export const Reports_tokhaikhautruthuetncn = { id: '1995745C-2F8B-4BC1-87F6-DB91C00A3FEE', text: 'Tờ khai khấu trừ thuế thu nhập cá nhân', link: '/baocao/tokhaikhautruthuetncn/1995745C-2F8B-4BC1-87F6-DB91C00A3FEE', huongdan: Global.App_url };
export const Reports_tokhaiquyettoantncn05qtt = { id: 'B51E115F-0E22-4F74-8AD5-FC515A48242A', text: 'Tờ khai quyết toán thuế thu nhập cá nhân', link: '/baocao/tokhaiquyettoantncn05qtt/B51E115F-0E22-4F74-8AD5-FC515A48242A', huongdan: Global.App_url };
export const Reports_phuluctokhaiquyettoantncn = { id: '863FCED5-08E5-46B6-91DB-620118726D5E', text: 'Phụ lục tờ khai quyết toán thuế thu nhập cá nhân', link: '/baocao/phuluctokhaiquyettoantncn/863FCED5-08E5-46B6-91DB-620118726D5E', huongdan: Global.App_url };
export const Reports_baocaonangluong = { id: '8810D236-AC6D-4458-9F18-4E7E1D7C4176', text: 'Báo cáo danh sách công chức đến hạn nâng lương', link: '/baocao/baocaonangluong/8810D236-AC6D-4458-9F18-4E7E1D7C4176', huongdan: Global.App_url };
//export const Reports_1040908 = { id: 'B430ADCD-BD41-40F9-804C-B6B05E5A730C', text: 'Danh sách cán bộ, công chức tham gia BHXH, BHYT', link: '/baocao/1040908', huongdan: Global.App_url };
export const Reports_1040909 = { id: '582B099C-76D3-4399-9D1C-289DB4A0E3F0', text: 'Tờ khai tham gia BHXH, BHYT', link: '/baocao/1040909', huongdan: Global.App_url };
export const Reports_1040910 = { id: 'A494E6ED-74C5-4AEE-BA31-8A7B3FC6C9C7', text: 'Danh sách cán bộ đề nghị cấp sổ BHXH, BHYT', link: '/baocao/1040910', huongdan: Global.App_url };
export const Reports_1040911 = { id: '98A447A0-E91A-4A9B-9169-3AFDA58DF15E', text: 'Bảng tính lãi truy thu BHXH, BHYT, BHTN', link: '/baocao/1040911', huongdan: Global.App_url };
export const Reports_1040912 = { id: '45FA9021-6550-4888-8E09-6F350FA73D79', text: 'Danh sách cán bộ đề nghị hưởng chế độ ốm đau', link: '/baocao/1040912', huongdan: Global.App_url };
export const Reports_1040913 = { id: 'D483205A-8858-4BDE-96A0-2B991E37AB55', text: 'Danh sách cán bộ đề nghị hưởng chế độ thai sản', link: '/baocao/1040913', huongdan: Global.App_url };
export const Reports_1040914 = { id: '3736646B-23AC-4FE2-A8FC-FBD5C17515D3', text: 'Danh sách cán bộ đề nghị hưởng trợ cấp nghỉ dưỡng sức phục hồi sức khỏe sau ốm đau', link: '/baocao/1040914', huongdan: Global.App_url };
export const Reports_1040915 = { id: '738FD509-AD99-4AD2-B9F3-56BE038EF066', text: 'Danh sách cán bộ đề nghị hưởng trợ cấp nghỉ dưỡng sức phục hồi sức khỏe sau thai sản', link: '/baocao/1040915', huongdan: Global.App_url };
export const Reports_1040916 = { id: '7EADB347-C139-4603-966B-D87DE3CC67D3', text: 'Thống kê thông tin bảo hiểm, báo cáo tăng, giảm và biến động bảo hiểm', link: '/baocao/1040916', huongdan: Global.App_url };



export const Reports_thongkethongtinchotuyen = { id: '4F528C26-490E-4281-A6D8-4F11D054738D', text: 'Thống kê thông tin chờ tuyển', link: '/baocao/thongkethongtinchotuyen/4F528C26-490E-4281-A6D8-4F11D054738D', huongdan: Global.App_url };
export const Reports_danhsachcanbogiahanhopdong = { id: '24931D8D-BCA4-4B79-9EF4-2E036A2947C4', text: 'Danh sách cán bộ gia hạn hợp đồng', link: '/baocao/danhsachcanbogiahanhopdong/24931D8D-BCA4-4B79-9EF4-2E036A2947C4', huongdan: Global.App_url };
export const Reports_danhsachcanbosaphethanhopdong = { id: 'E46DDBC7-5CDE-4592-AE6D-62515D558304', text: 'Danh sách cán bộ sắp hết hạn hợp đồng', link: '/baocao/danhsachcanbosaphethanhopdong/E46DDBC7-5CDE-4592-AE6D-62515D558304', huongdan: Global.App_url };
export const Reports_thongkedaotao = { id: '5A377C37-E0B5-4635-8180-178273912DD7', text: 'Thống kê tổng hợp đào tạo cán bộ', link: '/baocao/thongkedaotao/5A377C37-E0B5-4635-8180-178273912DD7', huongdan: Global.App_url };
export const Reports_danhsachcapthe = { id: 'EDDC9FC5-95BE-46D6-8B53-7029830C963B', text: 'Danh sách cấp thẻ theo ngày cấp', link: '/baocao/danhsachcapthe/EDDC9FC5-95BE-46D6-8B53-7029830C963B', huongdan: Global.App_url };
export const Reports_danhsachthesaphethan = { id: 'FD552462-B075-4B62-888D-48EEABAD4641', text: 'Danh sách thẻ sắp hết hạn', link: '/baocao/danhsachthesaphethan/FD552462-B075-4B62-888D-48EEABAD4641', huongdan: Global.App_url };
export const Reports_thongkecapthe = { id: 'F47CC968-E4A7-4C35-A861-A9510EAFBE87', text: 'Thống kê tổng hợp cấp thẻ theo đơn vị', link: '/baocao/thongkecapthe/F47CC968-E4A7-4C35-A861-A9510EAFBE87', huongdan: Global.App_url };
//export const Reports_1041007 = { id: '087A1541-8EEE-4D36-B6EA-29E5E4077C09', text: 'Báo cáo tổng hợp đào tạo, bồi dưỡng cán bộ', link: '/baocao/1041007/087A1541-8EEE-4D36-B6EA-29E5E4077C09', huongdan: Global.App_url };
//export const Reports_1041008 = { id: 'D1206E7C-205D-4E54-A52B-5A5865B3E9E1', text: 'Thống kê tổng hợp đào tạo cán bộ', link: '/baocao/1041008/D1206E7C-205D-4E54-A52B-5A5865B3E9E1', huongdan: Global.App_url };
//export const Reports_1041009 = { id: '7172E456-3797-40A7-913A-B449887F966A', text: 'Báo cáo thống kê, kế hoạch đào tạo', link: '/baocao/1041009/7172E456-3797-40A7-913A-B449887F966A', huongdan: Global.App_url };



export const Reports_1042000 = { id: '66589524-41D9-4389-8425-5F5C8760DCD0', text: 'Mẫu 01: BC thành tích đề nghị tặng Huân chương …..đối với tập thể ', link: '/baocao/1042000/66589524-41D9-4389-8425-5F5C8760DCD0', huongdan: Global.App_url };
export const Reports_1042001 = { id: '1D14A06F-35CF-4996-824C-FD7606715FA5', text: 'Mẫu 02: BC thành tích đề nghị tặng Huân chương …..đối với cá nhân', link: '/baocao/1042001/1D14A06F-35CF-4996-824C-FD7606715FA5', huongdan: Global.App_url };
export const Reports_1042002 = { id: 'D9CD5A32-75B7-4162-9496-8A2E9A107265', text: 'Mẫu 03: BC thành tích đề nghị tặng (truy tặng) huân chương cho cá nhân có quá trình cống hiến', link: '/baocao/1042002/D9CD5A32-75B7-4162-9496-8A2E9A107265', huongdan: Global.App_url };
export const Reports_1042003 = { id: 'C9E9962F-0D2C-441A-8145-801A1C242E97', text: 'Mẫu 04: BC thành tích đề nghị phong tặng danh hiệu Anh hùng cho tập thể', link: '/baocao/1042003/C9E9962F-0D2C-441A-8145-801A1C242E97', huongdan: Global.App_url };
export const Reports_1042004 = { id: '8702C998-CB06-4176-BF33-7BAFE78F8889', text: 'Mẫu 05: BC thành tích đề nghị phong tặng danh hiệu Anh hùng cho cá nhân', link: '/baocao/1042004/8702C998-CB06-4176-BF33-7BAFE78F8889', huongdan: Global.App_url };
export const Reports_1042005 = { id: 'B06932FA-E5C6-4E77-91D3-7DD19EC8DACD', text: 'Mẫu 06: BC thành tích đề nghị tặng Huân chương …..đối với tập thể/ cá nhân có thành tích đột xuất', link: '/baocao/1042005/B06932FA-E5C6-4E77-91D3-7DD19EC8DACD', huongdan: Global.App_url };
export const Reports_1042006 = { id: 'BA2807D4-CACA-4F1B-A1E7-32A95701EF04', text: 'Mẫu 07: BC thành tích đề nghị khen thưởng theo đợt thi đua hoặc theo chuyên đề (cho tập thể, cá nhân)', link: '/baocao/1042006/BA2807D4-CACA-4F1B-A1E7-32A95701EF04', huongdan: Global.App_url };
export const Reports_1042007 = { id: '892DF702-50E8-4220-B18C-FE8D342C7F80', text: 'Mẫu 08: BC thành tích đề nghị khen thưởng Huân chương ...cho tập thể, cá nhân nước ngoài)', link: '/baocao/1042007/892DF702-50E8-4220-B18C-FE8D342C7F80', huongdan: Global.App_url };
export const Reports_1042008 = { id: 'DC744DBD-1AF1-4729-85DA-C00FEEB17F96', text: 'Báo cáo tổng hợp thành tích khen thưởng tập thể ', link: '/baocao/1042008/DC744DBD-1AF1-4729-85DA-C00FEEB17F96', huongdan: Global.App_url };
export const Reports_1042009 = { id: '8F901FAC-D052-4C0E-923C-2A263649BBE3', text: 'Báo cáo tổng hợp thành tích khen thưởng cá nhân', link: '/baocao/1042009/8F901FAC-D052-4C0E-923C-2A263649BBE3', huongdan: Global.App_url };
export const Reports_lichsukhenthuongtapthe = { id: '66C31F6A-AAF8-40E5-A27C-9611F4747B90', text: 'Báo cáo lịch sử thành tích khen thưởng tập thể ', link: '/baocao/lichsukhenthuongtapthe/66C31F6A-AAF8-40E5-A27C-9611F4747B90', huongdan: Global.App_url };
export const Reports_lichsukhenthuongcanhan = { id: 'F7C22713-A582-4B08-A222-116EBEAD6C6F', text: 'Báo cáo lịch sử thành tích khen thưởng cá nhân', link: '/baocao/lichsukhenthuongcanhan/F7C22713-A582-4B08-A222-116EBEAD6C6F', huongdan: Global.App_url };



export const Reports = {
  id: '',
  text: 'Báo cáo',
  link: '/reports',
  icon: 'fa fas fa-chart-area',
  submenu: [
    {
      id: '',
      text: 'Báo cáo thông tin cán bộ',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu:
        [
          Reports_soyeulylich2c,
          Reports_thongkechatluongcongchuc,
          Reports_thongkechatluonglaodonghopdong,
          //Reports_1040816,
          //Reports_1040817,
          //Reports_1040818,
          // Reports_1040819,
          Reports_thongketanggiamcanbo,
          Reports_chitiettanggiamcanbo,
          Reports_bangtonghopchucdanh,
          //Reports_1040820,
          //Reports_1040821,
          //Reports_1040822,
          Reports_thongkecanbonghiviec,
          Reports_thongkecanbonghihuu,
          Reports_danhsachcanbothamgiabhxh,
          Reports_danhsachkyluat,
          Reports_danhsachkhenthuong,


        ]
    }
    ,
    {
      id: '',
      text: 'Báo cáo lương, bảo hiểm',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [

        //Reports_1040900,
        //Reports_1040901,
        //Reports_1040902,
        //Reports_1040903,
        // Reports_1040904,
        Reports_tokhaikhautruthuetncn,
        Reports_tokhaiquyettoantncn05qtt,
        Reports_phuluctokhaiquyettoantncn,
        Reports_danhsachcanbothamgiabhxh,
        Reports_baocaonangluong,
        //Reports_1040908,


        // tạm thời ẩn

        //Reports_1040909,
        //Reports_1040910,
        //Reports_1040911,
        //Reports_1040912,
        //Reports_1040913,
        //Reports_1040914,
        //Reports_1040915,
        //Reports_1040916,

      ]
    },

    {
      id: '',
      text: 'Báo cáo chờ tuyển, đào tạo',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_thongkethongtinchotuyen,
        Reports_danhsachcanbogiahanhopdong,
        Reports_danhsachcanbosaphethanhopdong,
        Reports_thongkedaotao,
        Reports_danhsachcapthe,
        Reports_danhsachthesaphethan,
        Reports_thongkecapthe,
        //Reports_1041007,
        //Reports_1041008,
        //Reports_1041009,
      ]
    },
    {
      id: '',
      text: 'Báo cáo thi đua',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        //Reports_1042000,
        //Reports_1042001,
        //Reports_1042002,
        //Reports_1042003,
        //Reports_1042004,
        //Reports_1042005,
        //Reports_1042006,
        //Reports_1042007,
        //Reports_1042008,
        //Reports_1042009,
        //Reports_danhsachkhenthuong,
        Reports_lichsukhenthuongtapthe,
        Reports_lichsukhenthuongcanhan,
      ]
    },
    {
      id: '',
      text: 'Báo cáo khác',
      link: '/elements',
      icon: 'fa fa-list-ul',
      submenu: [
        Reports_danhsachcongchuc,
        //Reports_tonghoptanggiamcanbo,

        Reports_dieuchuyencanbo,
        Reports_danhsachcanbodabonhiem,
        Reports_danhsachcanbohethanbonhiem,
        Reports_danhsachcanbothaydoichucvu,
        //Reports_1040837,
        //Reports_1040838,
        Reports_tonghopdotuoicanbo,
      ]
    }


    //, Reports_ketquakinhdoanh
  ]
};
//--------------------danh mục
export const Lists_nguonkinhphi = {
  id: '9840B305-82FD-4EB9-B275-5ED4B58F8282',
  text: 'Độ khẩn',
  link: '/danhmuc/nguonkinhphi',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_chuong = {
  id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
  text: 'Độ mật',
  link: '/danhmuc/chuong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaikhoan = {
  id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
  text: 'Tội danh',
  link: '/danhmuc/loaikhoan',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_tieumuc = {
  id: '5E79BF59-78D9-4C54-8EF7-0A242F5CBC24',
  text: 'Loại vụ việc',
  link: '/danhmuc/tieumuc',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_khachhang = {
  id: '2CEA2A10-9E2A-4EDF-969A-B4DFBE99C48A',
  text: 'Loại án',
  link: '/danhmuc/khachhang',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_nhacungcap = {
  id: 'DE964E8B-BE82-417F-A7DF-2CFB240E8E44',
  text: 'Loại công việc',
  link: '/danhmuc/nhacungcap',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_caphat = {
  id: 'D02C046F-FADD-42E4-B0E1-C78663076640',
  text: 'Trách nhiệm',
  link: '/danhmuc/hinhthuccapphat',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_loaitaisan = {
  id: '96A4CB47-2CCF-48FF-B49B-EC55DE24AFEF',
  text: 'Loại tài sản',
  link: '/danhmuc/loaitaisan',
  visible: true,
  huongdan: Global.App_url
};



export const Lists_linhvuc = {
  id: '9840B305-82FD-4EB9-B275-5ED4B58F8282',
  text: 'Lĩnh vực',
  link: '/danhmuc/linhvuc',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_loaivuviec = {
  id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
  text: 'Loại vụ việc',
  link: '/danhmuc/loaivuviec',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaicongviec = {
  id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
  text: 'Loại công việc',
  link: '/danhmuc/loaicongviec',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_trangthaixuly = {
  id: '5E79BF59-78D9-4C54-8EF7-0A242F5CBC24',
  text: 'Trạng thái xử lý',
  link: '/danhmuc/trangthaixuly',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_bienphapnghiepvu = {
  id: 'D02C046F-FADD-42E4-B0E1-C78663076640',
  text: 'Biện pháp nghiệp vụ',
  link: '/danhmuc/bienphapnghiepvu',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_ketquatraloi = {
  id: 'ABD85401-87F6-4EB8-BD26-2A9713DF53D8',
  text: 'Kết quả trả lời',
  link: '/danhmuc/ketquatraloi',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_domat = {
  id: 'A2E1B866-FE5D-4013-B65F-60DFA1A14620',
  text: 'Độ mật',
  link: '/danhmuc/domat',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_dokhan = {
  id: '9C0B41B7-CA5D-494C-9D17-877FDA70E1FF',
  text: 'Độ khẩn',
  link: '/danhmuc/dokhan',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_trachnhiem = {
  id: '2F6B699E-3843-43E7-B2D6-ADCB7C790B40',
  text: 'Trách nhiệm',
  link: '/danhmuc/trachnhiem',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaian = {
  id: 'C984553F-B0E6-454D-BE82-5AB776E76763',
  text: 'Loại án',
  link: '/danhmuc/loaian',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaitoidanh = {
  id: 'C4BF3734-6CA4-4491-9A2C-A6971D28FFE9',
  text: 'Loại tội danh',
  link: '/danhmuc/loaitoidanh',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_toidanh = {
  id: '73F13C3A-1C1A-466E-96C5-A20E79F0105D',
  text: 'Danh mục tội danh',
  link: '/danhmuc/toidanh',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_canbo = {
  id: '9B6F13B5-88F8-4CF1-90CF-DAE04C849B26',
  text: 'Cán bộ',
  link: '/danhmuc/canbo',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_phongban = {
  id: 'C83F032C-8834-44D8-94B5-D9E5A91D9A56',
  text: 'Phòng ban',
  link: '/danhmuc/phongban',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaitailieu = {
  id: '0AF84C3A-B45C-4047-94DE-9D1D8D506201',
  text: 'Loại tài liệu',
  link: '/danhmuc/loaitailieu',
  visible: true,
  huongdan: Global.App_url
};



export const Lists_capham = {
  id: '4316191F-5C48-413C-82B3-DFD870C0FAFE',
  text: 'Cấp hàm',
  link: '/danhmuc/capham',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_vaitro = {
  id: '532A61EA-D765-844B-8CBF-E610B209E332',
  text: 'Vai trò',
  link: '/danhmuc/vaitro',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_gioitinh = {
  id: '362DA8C9-9F20-4FFC-BE8B-9AF376F2F32E',
  text: 'Giới tính',
  link: '/danhmuc/gioitinh',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaidoituong = {
  id: 'B8A00ED6-8EA0-462B-B1D0-D41466880EFB',
  text: 'loại đối tượng',
  link: '/danhmuc/loaidoituong',
  visible: true,
  huongdan: Global.App_url
};





export const Lists_dantoc = { id: '4DEC2574-8660-4055-8B68-7A0E447045D1', text: 'Danh mục dân tộc', link: '/danhmuc/dantoc', huongdan: Global.App_url };
export const Lists_tongiao = { id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0', text: 'Danh mục tôn giáo', link: '/danhmuc/tongiao', huongdan: Global.App_url };
export const Lists_loaihopdong = { id: '5E79BF59-78D9-4C54-8EF7-0A242F5CBC24', text: 'Danh mục loại hợp đồng lao động', link: '/danhmuc/loaihopdong', huongdan: Global.App_url };
export const Lists_hinhthucnghiviec = { id: 'D02C046F-FADD-42E4-B0E1-C78663076640', text: 'Danh mục hình thức nghỉ việc', link: '/danhmuc/hinhthucnghiviec', huongdan: Global.App_url };
export const Lists_hinhthuccongtacnuocngoai = { id: 'ABD85401-87F6-4EB8-BD26-2A9713DF53D8', text: 'Danh mục hình thức công tác nước ngoài', link: '/danhmuc/hinhthuccongtacnuocngoai', huongdan: Global.App_url };
export const Lists_coquanbanhanh = { id: 'A2E1B866-FE5D-4013-B65F-60DFA1A14620', text: 'Danh mục cơ quan ban hành', link: '/danhmuc/coquanbanhanh', huongdan: Global.App_url };
export const Lists_loaicanbo = { id: '9C0B41B7-CA5D-494C-9D17-877FDA70E1FF', text: 'Danh mục loại cán bộ', link: '/danhmuc/loaicanbo', huongdan: Global.App_url };


export const Lists_diadanh = { id: 'C4BF3734-6CA4-4491-9A2C-A6971D28FFE9', text: 'Danh mục địa danh, vùng lãnh thổ', link: '/danhmuc/diadanh', huongdan: Global.App_url };
export const Lists_loaisangkien = { id: '73F13C3A-1C1A-466E-96C5-A20E79F0105D', text: 'Danh mục loại sáng kiến', link: '/danhmuc/loaisangkien', huongdan: Global.App_url };


export const Lists_chucvudang = { id: '2F6B699E-3843-43E7-B2D6-ADCB7C790B40', text: 'Danh mục chức vụ đảng, đoàn thể', link: '/danhmuc/chucvudang', huongdan: Global.App_url };
export const Lists_chucvu = { id: 'C984553F-B0E6-454D-BE82-5AB776E76763', text: 'Danh mục chức vụ', link: '/danhmuc/chucvu', huongdan: Global.App_url };

export const Lists_diengiadinhchinhsach = { id: '9B6F13B5-88F8-4CF1-90CF-DAE04C849B26', text: 'Danh mục diện gia đình chính sách', link: '/danhmuc/diengiadinhchinhsach', huongdan: Global.App_url };
export const Lists_loaiquanhegiadinh = { id: '2CEA2A10-9E2A-4EDF-969A-B4DFBE99C48A', text: 'Danh mục loại quan hệ gia đình', link: '/danhmuc/loaiquanhegiadinh', huongdan: Global.App_url };
export const Lists_thanhphangiadinh = { id: 'DE964E8B-BE82-417F-A7DF-2CFB240E8E44', text: 'Danh mục thành phần gia đình', link: '/danhmuc/thanhphangiadinh', huongdan: Global.App_url, border: 'co' };
export const Lists_hinhthucdaotao = { id: '4316191F-5C48-413C-82B3-DFD870C0FAFE', text: 'Danh mục hình thức đào tạo', link: '/danhmuc/hinhthucdaotao', huongdan: Global.App_url };
export const Lists_chuyennganhdaotao = { id: '532A61EA-D765-844B-8CBF-E610B209E332', text: 'Danh mục chuyên ngành đào tạo', link: '/danhmuc/chuyennganhdaotao', huongdan: Global.App_url };
export const Lists_trinhdodaotao = { id: '362DA8C9-9F20-4FFC-BE8B-9AF376F2F32E', text: 'Danh mục trình độ đào tạo', link: '/danhmuc/trinhdodaotao', huongdan: Global.App_url };
export const Lists_xeploaidaotao = { id: 'B8A00ED6-8EA0-462B-B1D0-D41466880EFB', text: 'Danh mục hạng văn bằng', link: '/danhmuc/hangvanbang', huongdan: Global.App_url };
export const Lists_loaihinhdaotao = { id: 'C83F032C-8834-44D8-94B5-D9E5A91D9A56', text: 'Danh mục loại hình đào tạo', link: '/danhmuc/loaihinhdaotao', huongdan: Global.App_url };
export const Lists_truongdaotao = { id: '4A625C2C-BBCF-4EE1-84B0-2BDC221201B7', text: 'Danh mục trường đào tạo', link: '/danhmuc/truongdaotao', huongdan: Global.App_url };
export const Lists_trinhdoquanlynhanuoc = { id: '82A13F03-EC73-4C68-83E0-BABA4C406121', text: 'Danh mục trình độ quản lý nhà nước', link: '/danhmuc/trinhdoquanlynhanuoc', huongdan: Global.App_url };
export const Lists_trinhdongoaingu = { id: '4858CE5D-DFF3-4C07-8BA5-5A5BF417013D', text: 'Danh mục ngoại ngữ', link: '/danhmuc/trinhdongoaingu', huongdan: Global.App_url };
export const Lists_hocham = { id: '47388AF9-A030-4FD9-BE36-0D8486613028', text: 'Danh mục học hàm', link: '/danhmuc/hocham', huongdan: Global.App_url };
export const Lists_hinhthuctuyendung = { id: 'D85A5EC3-BB49-4270-BDC0-E4D9AF2C2371', text: 'Danh mục hình thức tuyển dụng', link: '/danhmuc/hinhthuctuyendung', huongdan: Global.App_url };
export const Lists_nguontuyendung = { id: '55D96A87-BF6C-478C-ACB1-D15EF48F04F2', text: 'Danh mục nguồn tuyển dụng', link: '/danhmuc/nguontuyendung', huongdan: Global.App_url };

export const Lists_capkhenthuong = { id: '09F950DC-0F5C-4587-8826-EB70281753C2', text: 'Danh mục cấp khen thưởng', link: '/danhmuc/capkhenthuong', huongdan: Global.App_url };
export const Lists_hinhthuckhenthuong = { id: '7649BA2A-7109-4C93-98B6-83EDC2162FF6', text: 'Danh mục hình thức khen thưởng', link: '/danhmuc/hinhthuckhenthuong', huongdan: Global.App_url };
export const Lists_danhhieukhenthuong = { id: '8C99F190-D26B-4F02-8895-A255A862EE4A', text: 'Danh mục danh hiệu khen thưởng', link: '/danhmuc/danhhieukhenthuong', huongdan: Global.App_url };
export const Lists_botieuchi = { id: '33945FD1-A14F-4E33-8245-833B33145B14', text: 'Bộ tiêu chí khen thưởng', link: '/danhmuc/bochitieu', huongdan: Global.App_url };
export const Lists_donvingoai = { id: 'BEC6103F-B405-43FB-BDDD-5952B920A765', text: 'Danh mục Đơn vị khen thưởng ngoài ngành', link: '/danhmuc/donvingoai', huongdan: Global.App_url };
export const Lists_capkyluat = { id: 'A2BA250E-34D0-49F4-AC02-2F84AA8A3437', text: 'Danh mục cấp kỷ luật', link: '/danhmuc/capkyluat', huongdan: Global.App_url };
export const Lists_hinhthuckyluat = { id: 'A5AB9C8C-C0EA-45A2-889F-F649325C12DC', text: 'Danh mục hình thức kỷ luật', link: '/danhmuc/hinhthuckyluat', huongdan: Global.App_url };
export const Lists_nhomngachluong = { id: '86CF2C93-A0BD-4737-A358-D3312E5F0F44', text: 'Danh mục nhóm ngạch lương', link: '/danhmuc/nhomngachluong', huongdan: Global.App_url };
export const Lists_ngachluong = { id: 'BBD57249-92F5-4E6C-9CE8-23E2775253C9', text: 'Danh mục ngạch lương', link: '/danhmuc/ngachluong', huongdan: Global.App_url };

export const Lists_chude = { id: '6B6A7530-5978-4F65-ADFA-33345900CF7E', text: 'Danh mục chủ đề', link: '/danhmuc/chude', huongdan: Global.App_url };



export const DanhMucs = [Lists_nguonkinhphi, Lists_loaikhoan, Lists_tieumuc, Lists_caphat,
  Lists_canbo, Lists_khachhang, Lists_nhacungcap, Lists_linhvuc, Lists_loaivuviec, Lists_loaicongviec
  , Lists_trangthaixuly, Lists_bienphapnghiepvu, Lists_ketquatraloi, Lists_domat, Lists_dokhan
  , Lists_trachnhiem, Lists_loaian, Lists_loaitoidanh, Lists_toidanh, Lists_canbo, Lists_phongban
  , Lists_loaitailieu, Lists_diadanh, Lists_chucvu, Lists_capham, Lists_vaitro, Lists_gioitinh, Lists_loaidoituong, Lists_loaicanbo
  ,  LuongBaoHiems_dienbienluongngachbac, LuongBaoHiems_dienbienphucapluong, Lists_giaidoanquyhoach
]
export const Lists = {
  id: '',
  text: 'Danh mục',
  link: '/elements',
  icon: 'fa fa-list-ul',
  submenu: [
    Lists_chude,
    Lists_dantoc,
    Lists_tongiao,
    Lists_loaihopdong,
    Lists_hinhthucnghiviec,
    Lists_hinhthuccongtacnuocngoai,
    Lists_coquanbanhanh,
    Lists_loaicanbo,
    // Lists_chucvudang,
    Lists_chucvu,
    Lists_diadanh,
    //Lists_loaisangkien,

    Lists_diengiadinhchinhsach,
    Lists_loaiquanhegiadinh,
    Lists_thanhphangiadinh,
    Lists_hinhthucdaotao,
    Lists_chuyennganhdaotao,

    // danh mục khác
    Lists_trinhdodaotao,
    Lists_xeploaidaotao,
    Lists_loaihinhdaotao,
    Lists_truongdaotao,
    Lists_trinhdoquanlynhanuoc,
    Lists_trinhdongoaingu,
    Lists_hocham,
    Lists_hinhthuctuyendung,
    Lists_nguontuyendung,
    Lists_capkhenthuong,
    Lists_hinhthuckhenthuong,
    Lists_botieuchi,
    Lists_danhhieukhenthuong,

    // Lists_donvingoai,
    Lists_capkyluat,
    Lists_hinhthuckyluat,
    //Lists_nhomngachluong,
    Lists_ngachluong,
   
    // Lists_giaidoanquyhoach,

  ]

};


//-------------------tiện ích
export const Ultil_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Quản lý người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const Ultil_phanquyen = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Vai trò ngươi dùng',
  link: '/quantri/vaitro',
  huongdan: Global.App_url
};
export const Ultil_doimatkhau = {
  id: '',
  text: 'Đổi mật khẩu',
  link: '/quantri/doimatkhau',
  huongdan: Global.App_url
};
export const Ultil_cauhinhnhapdulieutuexcel = {
  id: '1EC79DE0-51D4-43EF-BF16-5C8E94CB1CD1',
  text: 'Cấu hình nhập dữ liệu từ excel',
  link: '/quantri/maubaocao',
  huongdan: Global.App_url
};

export const Ultil_quanlytin = {
  id: '1EC79DE0-51D4-43EF-BF16-5C8E94CB1CD1',
  text: 'Quản lý tin tức',
  link: '/quantri/quanlytintuc',
  huongdan: Global.App_url
};



export const Ultil_bug = {
  id: '5159E97E-2428-4C72-999D-DE2F444B2D39',
  text: 'Quản lý test',
  link: '/quantri/bug',
  huongdan: Global.App_url
};
export const Ultil_nhatkytruycap = {
  id: '2391F2AB-836E-48E9-B8C0-BE1FC543E387',
  text: 'Nhật ký truy cập',
  link: '/quantri/nhatkytruycap',
  border: 'co',
  huongdan: Global.App_url
};


export const Ultil_timdoituong = {
  id: '3E366F69-BDEE-4D73-963A-6DCAA2BC070B',
  text: 'Tra cứu tìm kiếm hồ sơ cán bộ',
  link: '/nhaplieu/timdoituong',
  huongdan: Global.App_url
};
export const Ultil_kiemtraloi = {
  id: 'C641370B-520E-48CF-A95E-D58E82607D42',
  text: 'Kiểm tra lỗi',
  link: '/nhaplieu/kiemtraloi',
  huongdan: Global.App_url
};
export const Ultil_tailieu = {
  id: '4034D0E4-356E-4CEB-9C1A-2DD64882807C',
  text: 'Quản lý tài liệu',
  link: '/quantri/quanlytailieu',
  huongdan: Global.App_url
};


export const Ultil = {
  id: '',
  text: 'Tiện ích',
  link: '/headingComponents',
  icon: 'fa fas fa-th',
  submenu: [
    //Ultil_timdoituong,
    //Ultil_kiemtraloi,
    // Ultil_danhsochungtu,
    // Ultil_khoaso,
    Ultil_tailieu,
    Ultil_quanlytin,
    //Ultil_nhatkytruycap,
    //Ultil_cauhinhnhapdulieutuexcel,
    //Ultil_cauhinhdongthoi,
    //Ultil_hachtoanquy,
    //Ultil_hachtoankhobac,
    //Ultil_hachtoantaisan,
    //Ultil_hachtoanmuahang,
    //Ultil_hachtoanluong,


  ]
};


//----------------------quản trị
export const System_vaitro = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Vai trò',
  link: '/quantri/vaitro',
  border: 'co',
  huongdan: Global.App_url
};
export const System_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const System_thamso = {
  id: 'EB0CE66D-656D-48C9-8BBA-E74309682A18',
  text: 'Tham số hệ thống',
  link: '/quantri/thamso',
  huongdan: Global.App_url
};
export const Ultil_donvi = {
  id: '610562E5-AA28-45CB-811B-F349395DA524',
  text: 'Quản lý đơn vị',
  link: '/quantri/donvi',
  huongdan: Global.App_url
};
export const Ultil_phanhe = {
  id: 'E84CDFB9-E9BB-4E79-9CEB-74BF2C175331',
  text: 'Cấu trúc phân hệ',
  link: '/quantri/phanhe',
  border: 'co',
  huongdan: Global.App_url
};

export const System_history = {
  id: '',
  text: 'Bản mới',
  link: '/danhmuc/history',
  icon: 'fa fas fa-history',
  huongdan: Global.App_url
};
export const Ultil_saoluudulieu = {
  id: 'DC4D283D-4181-4773-BE7E-D576B1430EB8',
  text: 'Sao lưu dữ liệu',
  link: '/quantri/saoluudulieu',
  huongdan: Global.App_url
};
export const Ultil_nhatkysaoluu = {
  id: '9B779F0A-3D4B-4CDB-87BB-F41529819CC9',
  text: 'Nhật ký sao lưu',
  link: '/quantri/nhatkysaoluu',
  huongdan: Global.App_url
};
export const System = {
  id: '',
  text: 'Hệ thống',
  link: '',
  icon: 'fa fa-cog',
  submenu: [
    System_thamso, Ultil_saoluudulieu, Ultil_nhatkysaoluu
    , Ultil_nhatkytruycap, System_nguoidung, System_vaitro
    , Ultil_donvi
    //, Ultil_phanhe
    //, System_history
    //, Ultil_bug
  ],
  huongdan: Global.App_url
};

//-----------------------------------------

//------------Menu Báo Vĩnh Phúc ----------------
export const Notify = {
  id: '23199FED-325F-48F7-8E7C-3A83E68F3340',
  text: 'Thông báo',
  link: '/quantri/notify',
  icon: 'fa fa-th-large',
  submenu: null
};



export const Operational_Article_Goc = {
  id: 'C7CE86D5-2FF0-4BA5-9B93-DAA964D03B6B',
  text: 'Bài viết',
  link: '/task/bai-viet-goc',
  huongdan: Global.App_url
};
export const Operational_Article = {
  id: 'A78618AD-EF7F-44E6-A6E2-201AF7B6E2DA',
  text: 'Xử lý bài viết',
  link: '/task/xu-ly-bai-viet',
  huongdan: Global.App_url
};
export const Operational_DocBong = {
  id: '70CDBFE1-9004-423B-88B0-3A9AD9711A78',
  text: 'Đọc bông',
  link: '/task/danh-sach-bong',
  huongdan: Global.App_url
};
export const Operational_KeHoach = {
  id: '4419D77E-56A2-496D-A211-BDB3CFDFA8DE',
  text: 'Kế hoạch',
  link: '/task/ke-hoach',
  huongdan: Global.App_url
};
export const Operational_SoBao = {
  id: '24BD5439-2CEB-4162-92D4-EBD165323475',
  text: 'Số báo',
  link: '/task/so-bao',
  huongdan: Global.App_url
};
export const Operational_ThongKe = {
  id: '47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F',
  text: 'Thống kê',
  link: '/baocao/thongkebaiviet/47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F',
  huongdan: Global.App_url
};
export const Operational_DanhBa = {
  id: 'CE6CEDEC-5F75-409A-8FA5-B5BF923FABFE',
  text: 'Danh bạ',
  link: '/quantri/danhba',
  huongdan: Global.App_url
};

export const Operational_Saved = {
  id: 'DA78BAD3-F84D-4DB8-8091-19389C4FA63F',
  text: 'Lưu bài viết',
  link: '/task/luubaiviet/1',
  huongdan: Global.App_url
};
export const Operational_BongSaved = {
  id: '56581198-1C47-40E8-B0DB-13113F479FE4',
  text: 'Lưu số báo',
  link: '/task/luusobao/1',
  huongdan: Global.App_url
};
export const Operational_TimKiem = {
  id: '650A4090-1D86-458B-B0E0-4F5DB43E2CD6',
  text: 'Tìm kiếm',
  link: '/task/tim-bai-viet',
  huongdan: Global.App_url
};
 
export const Operational = {
  id: '',
  text: 'Tác nghiệp',
  link: '',
  icon: 'fa fa-tasks',
  submenu: [Operational_Article_Goc,
    //Operational_Article,
    Operational_DocBong,
    Operational_KeHoach,
    Operational_SoBao,
    Operational_ThongKe
    , Operational_TimKiem
    , Operational_DanhBa
    , Operational_Saved
    , Operational_BongSaved
  ]
};
 
export const Archives_BaiViet = { id: '73F13C3A-1C1A-466E-96C5-A20E79F0105D', text: 'Bài viết', link: '/task/sitebaiviet', huongdan: Global.App_url };
export const Archives_VideoCho = { id: '203EEA83-2293-45E6-B80D-ED7ED80565A6', text: 'Video chờ duyệt', link: '/task/sitevideocho', huongdan: Global.App_url };
export const Archives_Video = { id: 'E0B3FB60-AA1B-4A0F-AAEE-6364A14E475E', text: 'Truyền hình số', link: '/task/truyenhinhso', huongdan: Global.App_url };
export const Archives_BaiVietCho = { id: 'B82D62C4-3589-4EEC-B442-F7C85767A990', text: 'Bài viết chờ duyệt', link: '/task/sitebaivietcho', huongdan: Global.App_url };
export const Archives_BaiVietBinhLuan = { id: '05EE054A-762F-4942-AC7B-661B8FB0C02E', text: 'Bình luận', link: '/task/sitebaivietbinhluan', huongdan: Global.App_url };
export const Archives_TuDien = { id: 'A258D31D-5EE7-466C-8DAD-641F0F1B70FB', text: 'Từ điển', link: '/quantri/tudien', huongdan: Global.App_url };


export const Archives = {
  id: 'EC60D2A4-3345-490E-96CD-F4954D7DA4C8',
  text: 'Website',
  link: '',
  icon: 'fab fa-internet-explorer',
  submenu: [Archives_BaiViet,
    Archives_BaiVietCho,
    Archives_Video,
    Archives_VideoCho,
    Archives_BaiVietBinhLuan,
    Archives_TuDien
  ]
};

export const Advertisement = {
  id: '9734BF3A-6E36-4D85-8C49-EEE122CAD547',
  text: 'Quảng cáo',
  link: '/quantri/quangcao',
  icon: 'fa fa-volume-up',
  submenu: null
};

export const Release = {
  id: '4C60DBAA-C69E-4878-B214-933D653D4F44',
  text: 'Phát hành',
  link: '/quantri/phathanh',
  icon: 'fa fa-paper-plane',
  submenu: null
};

export const Library_TaiLieu = {
  id: '6EAC2589-462E-4589-9BE0-35E758788A09',
  text: 'Thư viện tài liệu',
  link: '/quantri/tailieu',
  huongdan: Global.App_url
};
export const Library_Anh = {
  id: '756C8AD5-A7C8-445F-89C9-AB70EEA86C64',
  text: 'Thư viện ảnh',
  link: '/quantri/thuvien',
  huongdan: Global.App_url
};

export const Library_BinhChon = {
  id: '795B4D34-EDAA-486A-B2A6-F5332EE61E32',
  text: 'Bình chọn',
  link: '/quantri/binhchon',
  huongdan: Global.App_url
};

export const Library = {
  id: '',
  text: 'Thư viện',
  link: '',
  icon: 'fa fa-book',
  submenu: [Library_TaiLieu, Library_Anh, Library_BinhChon]
};

export const Systems_NguoiDung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Người dùng',
  link: '/quantri/bao-nguoi-dung',
  huongdan: Global.App_url
};
export const Systems_PhongBan = {
  id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
  text: 'Phòng ban',
  link: '/quantri/phong-ban',
  huongdan: Global.App_url
};
export const Systems_ChucVu = {
  id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
  text: 'Chức vụ',
  link: '/quantri/chuc-vu',
  huongdan: Global.App_url
};
export const Systems_MauSac = {
  id: 'ABD85401-87F6-4EB8-BD26-2A9713DF53D8',
  text: 'Màu sắc',
  link: '/quantri/mau-sac',
  huongdan: Global.App_url
};

export const Systems_AnPham = {
  id: '5E79BF59-78D9-4C54-8EF7-0A242F5CBC24',
  text: 'Ấn phẩm',
  link: '/quantri/an-pham',
  huongdan: Global.App_url
};


export const Systems_MucTin = {
  id: 'A2E1B866-FE5D-4013-B65F-60DFA1A14620',
  text: 'Mục tin ảnh',
  link: '/quantri/muc-tin',
  visible: true,
  huongdan: Global.App_url
};

export const Systems_NhomVideo = {
  id: '9C0B41B7-CA5D-494C-9D17-877FDA70E1FF',
  text: 'Nhóm video',
  link: '/quantri/nhom-tin',
  visible: true,
  huongdan: Global.App_url
};

export const Systems_tinhtp = { id: '2F6B699E-3843-43E7-B2D6-ADCB7C790B40', text: 'Danh mục địa giới hành chính', link: '/danhmuc/tinhtp', huongdan: Global.App_url };
export const Systems_coquan = { id: 'C984553F-B0E6-454D-BE82-5AB776E76763', text: 'Danh mục cơ quan trung ương, địa phương', link: '/danhmuc/coquan', huongdan: Global.App_url };
export const Systems_linhvuc = { id: 'C4BF3734-6CA4-4491-9A2C-A6971D28FFE9', text: 'Danh mục lĩnh vực hoạt động của doanh nghiệp', link: '/danhmuc/linhvuc', huongdan: Global.App_url };

export const Systems_coquanbaochi = { id: '60C56318-2E55-410B-BCE4-137DD099BC4D', text: 'Danh mục cơ quan báo chí', link: '/danhmuc/coquanbaochi', huongdan: Global.App_url };
export const Systems_nhaxuatban = { id: '139C1D16-0BE4-488B-88DE-395B209E037D', text: 'Danh mục nhà xuất bản', link: '/danhmuc/nhaxuatban', huongdan: Global.App_url };
export const Systems_phongvien = { id: '210F1FBE-DC42-43D8-9C79-6548D216761F', text: 'Danh mục phòng viên chính thức', link: '/danhmuc/phongvien', huongdan: Global.App_url };
export const Systems_congtacvien = { id: '669F83D4-80B9-4FB8-9CE4-70EB50939DB3', text: 'Danh mục cộng tác viên', link: '/danhmuc/congtacvien', huongdan: Global.App_url };
export const Systems_chuyenmuc = { id: '2693DA95-3EE8-4EA8-9BCB-3AF8B0C59551', text: 'Danh mục chuyên mục tin nội bộ', link: '/quantri/chuyenmuc', huongdan: Global.App_url };

export const Systems = {
  id: '',
  text: 'Quản trị',
  link: '',
  icon: 'fa fa-cogs',
  submenu: [Systems_NguoiDung, Ultil_phanquyen, Systems_PhongBan
    , Systems_ChucVu, Systems_AnPham, Systems_MauSac
    , Systems_MucTin, Systems_NhomVideo, Systems_chuyenmuc
    , Systems_tinhtp, Systems_coquan, Systems_linhvuc
    , Systems_coquanbaochi, Systems_nhaxuatban
    , Systems_phongvien, Systems_congtacvien
    , Ultil_nhatkytruycap]
}; 


export const menu = [ 
  Notify,
  Operational,
  Archives,
  Advertisement,
  Release,
  Library,
  Systems
];
